import React from "react";
import { View } from "react-native";
import Modal from "modal-enhanced-react-native-web";
import { colors } from "../../../const";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-regular-svg-icons";
import { PrimaryTitle } from "../../labels";
import Button from "../../form/Button";
import localize from "../../../localize";

function LogoutDialog({ onCancel, onLogout, ...other }) {


    return (
        <Modal
            animationIn="fadeIn"
            animationOut="bounceOut"
            backdropOpacity={0.4}
            style={{ justifyContent: "center", alignItems: "center" }}
            {...other}
        >
            <View style={{ backgroundColor: colors.white, borderRadius: 10, justifyContent: "center", alignItems: "center", paddingBottom: 40, paddingHorizontal: 20 }}>

                <Icon
                    icon={faTimesCircle}
                    color={colors.midnightBack}
                    style={{ right: 10, position: "absolute", top: 10, fontSize: 20 }}
                    onClick={onCancel}
                />

                <View style={{ marginVertical: 40 }}>
                    <PrimaryTitle size={14} align="center" weight="bold">
                        {localize.LOG_OUT}
                    </PrimaryTitle>
                    <View style={{ height: 10 }} />
                    <PrimaryTitle align="center">
                        {localize.Are_you_sure_you_want_to_log_out}
                    </PrimaryTitle>
                </View>
                <View style={{ width: "100%", paddingHorizontal: 35 }}>
                    <Button
                        title={localize.cancel}
                        onPress={onCancel}
                        size="small"
                        variant="outline"
                    />
                    <View style={{ height: 8 }} />
                    <Button
                        title={localize.Log_out}
                        onPress={onLogout}
                        size="small"
                    />
                </View>
            </View>
        </Modal>
    )
}

export default LogoutDialog;